export type AppToastVariant = 'success' | 'error';

export const DEFAULT_APP_TOAST_DURATION_MS = 4000;

export type AppToastPayload = {
  variant: AppToastVariant;
  title?: string;
  message: string;
  durationMs?: number;
};
